/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react';
import { blue } from '@theme/core/colors/color.palette';
import { DropDownProps, OptionProps } from '@types';
import { List } from '../../App.styled';
import Link from '@components/Link/Link';
import { ListWrapper, ListItems, Hr, BlueBar, MenuDropDownWrapper, CallUsLink, CallUsText } from './Dropdown.styled';
import isEmpty from 'lodash/isEmpty';
import memoize from 'fast-memoize';

const getDropDownItem = memoize((_ele: OptionProps, _onClick: any) => {
    const { name, url, id } = _ele;
    switch (id) {
        case 'manage_account_sso_url':
        case 'account_details_sso_url':
        case 'recurring_payment_sso_url':
        case 'payment_history_sso_url':
        case 'all_documents_sso_url':
        case 'pay_now_sso_url':
            return (
                <>
                    <Link id={`${id}_link`} href={`/?route=${id}`} decoration="none">
                        {name}
                    </Link>
                </>
            );
        case 'call_at':
            return (
                <>
                    <CallUsLink id={`${id}_link`} decoration="none">
                        {name}
                    </CallUsLink>
                    <CallUsText>{name}</CallUsText>
                </>
            );
        default:
            return (
                <Link
                    id={`${id}_link`}
                    onClick={() => {
                        _onClick({ name, url });
                    }}
                    decoration="none"
                >
                    {name}
                </Link>
            );
    }
});

const MenuDropDown: React.FC<DropDownProps> = React.forwardRef(
    ({ options, onClick, fontSize = '16px', fontColor = `${blue}`, separator = false }, ref) => {
        return (
            <>
                <MenuDropDownWrapper id="menuDropDown">
                    <BlueBar />
                    <ListWrapper role="dropdown" ref={ref}>
                        <List>
                            {!isEmpty(options) &&
                                options.map(ele => (
                                    <React.Fragment key={ele.id}>
                                        <ListItems
                                            fontSize={fontSize}
                                            fontColor={fontColor}
                                            disabled={ele.disabled}
                                            key={ele.name}
                                            id={ele.name}
                                        >
                                            {getDropDownItem(ele, onClick)}
                                        </ListItems>
                                        {separator && <Hr role="separator" />}
                                    </React.Fragment>
                                ))}
                        </List>
                    </ListWrapper>
                </MenuDropDownWrapper>
            </>
        );
    }
);

export default MenuDropDown;
